import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Body2 } from 'ui/theme';
import { useUpdateIngestionPolicies } from '../hooks';

type Props = {
  onClose: () => void;
};

const TEXT = {
  ID: 'allow-new-events',
  TITLE: 'Allow new custom events?',
  BODY_TEXT: 'Allow new custom events to be added to this project?',
  PRIMARY_BUTTON_TEXT: 'Allow new events',
};

export const AllowNewEventsModal = ({ onClose }: Props) => {
  const { allow } = useUpdateIngestionPolicies();

  const handleAllowNewEventsClick = async () => {
    await allow();
  };

  return (
    <Modal
      id={TEXT.ID}
      isModalOpen={true}
      onClose={onClose}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader onClose={onClose}>{TEXT.TITLE}</ModalHeader>
      <ModalBody>
        <Body2>{TEXT.BODY_TEXT}</Body2>
      </ModalBody>
      <ModalFooter onClose={onClose}>
        <PrimaryButton onClick={handleAllowNewEventsClick} size={BUTTON_SIZES.LARGE}>
          {TEXT.PRIMARY_BUTTON_TEXT}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
